// src/pages/address/hooks/useAddressManagementScreen.ts
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApi } from "../../api/api";
import {
  setAddresses,
  selectAddresses,
} from "../../store/slices/addressSlice";

export const useAddressManagementScreen = () => {
  const api = getApi();
  const [adding, setAdding] = useState(false);
  const dispatch = useDispatch();
  const addresses = useSelector(selectAddresses);

  const getList = useCallback(async () => {
    try {
      const result = await api.getAddressList();
      if (result) {
        dispatch(setAddresses(result));
      }
    } catch {}
  }, [api, dispatch]);

  const deleteAddress = useCallback(
    async (id: number) => {
      try {
        await api.deleteAddress(id);
        await getList();
      } catch {}
    },
    [api, getList],
  );

  const setDefaultAddress = useCallback(
    async (id: number) => {
      try {
        await api.setDefaultAddress(id);
        await getList();
      } catch {}
    },
    [api, getList],
  );

  const startAdding = () => setAdding(true);
  const closeForm = () => setAdding(false);

  return {
    addresses,
    getList,
    adding,
    startAdding,
    closeForm,
    setDefaultAddress,
    deleteAddress,
  };
};
